import { useMemo } from 'react'
import { useSelector } from 'react-redux'

const useIsModalOpen = (modalName) => {
  const modals = useSelector((state) => state.modals)
  return useMemo(() => modals.includes(modalName), [modals])
}

export default useIsModalOpen
